import { styled, css } from 'styled-components';

const StyledSearchForm = styled.form`
  display: flex;
  align-self: left;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0;
  background-color: #FFF;
`;

const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 0px !important;
`;

const StyledSearchInput = styled.input`
  flex: 1;           /* grow to fill remaining space */
  min-width: 0;      /* prevent flexbox from causing overflow */
  border: none;
  outline: none;
  font-size: ${props => props.theme.typography.baseFontSize.m};
  padding: 5px;
  color: #000;
  caret-color: #000;
  box-sizing: border-box;

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
  }
`;

const StyledSearchIcon = styled.img`
  height: 23px;
  font-size: 16px;
  padding: 0 10px;
  cursor: pointer;
`

export { StyledSearchForm, StyledSearchContainer, StyledSearchInput, StyledSearchIcon };
